import AppCommand from"../classes/AppCommand";/**
 * Sends an openAppSettings command to the app.
 */export default function openAppSettings(){var command=new AppCommand();command.setCommandName('openAppSettings').dispatch();}